import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
	Box,
	Button,
	Dialog,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

const LOCAL_STORAGE_KEY = "timocom_info_20032026";

export const PromotionDialog = () => {
	const { t, i18n } = useTranslation();
	const currentLang = i18n?.language || "pl";
	const [openPromotionPopup, setOpenPromotionPopup] = useState(false);

	// lock close button for 10 seconds
	const [lockCloseButton, setLockCloseButton] = useState(true);
	const [lockCounter, setLockCounter] = useState(10);

	// unlock button after 10 seconds
	useEffect(() => {
		if (lockCounter === 0) {
			setLockCloseButton(false);
			return;
		}

		const interval = setInterval(() => {
			setLockCounter((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, [lockCounter]);

	// show promotion popup only if today is the same or after the promotion date
	useEffect(() => {
		if (localStorage.getItem(LOCAL_STORAGE_KEY) !== "true") {
			setOpenPromotionPopup(true);
			localStorage.setItem(LOCAL_STORAGE_KEY, "true");
		}
	}, []);

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			onClose={(_e, reason) => {
				if (reason === "backdropClick") return;
				setOpenPromotionPopup(false);
			}}
			open={openPromotionPopup}
			disableEscapeKeyDown={true}
		>
			<Box sx={{ padding: "20px 30px" }}>
				{currentLang === "pl" ? <PLContent /> : <ENContent />}
				<Box
					sx={{
						width: "100%",
						display: "flex",
						justifyContent: "center",
						gap: "20px",
						marginTop: "30px",
					}}
				>
					<Button
						variant="contained"
						color="error"
						disabled={lockCloseButton}
						onClick={() => setOpenPromotionPopup(false)}
						sx={{
							textTransform: "uppercase",
							background: "#585858",
							"&:hover": {
								background: "#474646",
							},
						}}
					>
						{t("close")} {lockCounter > 0 && `(${lockCounter})`}
					</Button>
				</Box>
			</Box>
		</Dialog>
	);
};

const PLContent = () => {
	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Typography variant="h4" align="center" color="error" gutterBottom>
					Ważny komunikat.
				</Typography>
				<Typography variant="h6" sx={{ fontWeight: "600" }}>
					Szanowni Państwo,
				</Typography>
				<Typography variant="body1">
					Informujemy, że TIMOCOM zdecydował o zakończeniu współpracy z
					dostawcami oprogramowania, którzy umożliwiają publikowanie ładunków na
					kilka giełd jednocześnie. Po 2 latach wzorowej współpracy i uprzedniej
					akceptacji naszego modelu biznesowego decyzja ta jest dla nas
					niezrozumiała. W&nbsp;związku z tym{" "}
					<b>
						od 1 kwietnia publikowanie, usuwanie i odświeżanie ładunków na/z
						TIMOCOM będzie nadal możliwe
					</b>{" "}
					w sposób zautomatyzowany, ale wyłącznie w oparciu o naszą nową
					aplikację, którą będzie można <b>pobrać od 27 marca</b>. W systemie
					pojawi się komunikat o takiej możliwości.
				</Typography>
				<Typography variant="body1" sx={{ marginTop: "10px" }}>
					Nowe narzędzie niesie ze sobą kilka zmian:
				</Typography>
				<Box>
					<List dense={false} disablePadding={true}>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CloseIcon color="error" />
							</ListItemIcon>
							<ListItemText
								primary={`nie będzie już propozycji wolnych pojazdów z TIMOCOM przy ładunku`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CloseIcon color="error" />
							</ListItemIcon>
							<ListItemText
								primary={`edycja oferty nie zadziała na TIMOCOM (można to zastąpić opcją "Wystaw podobny" z pożądaną zmianą)`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText
								primary={`dodaliśmy możliwość aktywowania funkcji czarnej listy na TIMOCOM (lista wykluczeń)`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText
								primary={`do dyspozycji pozostaje manualne odświeżanie ofert na TIMOCOM`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText
								primary={`do opublikowanych ofert przewoźnik w TIMOCOM będzie mógł napisać na komunikatorze (obecnie tylko mailowo)`}
							/>
						</ListItem>
					</List>
				</Box>
			</Box>
			<Box sx={{ marginTop: "20px" }}>
				<Typography variant="h6" sx={{ fontWeight: "600" }}>
					Już niedługo kolejne nowe wartości dodane!
				</Typography>
				<Box sx={{ marginTop: "12px" }}>
					<Typography variant="body1">
						<span style={{ fontWeight: "600" }}>
							Transporeon oraz Comarr (CZ/SK)
						</span>{" "}
						&mdash; zintegrowaliśmy dodatkowo 2 giełdy transportowe
					</Typography>
				</Box>
				<Box sx={{ marginTop: "12px" }}>
					<Typography variant="body1">
						<span style={{ fontWeight: "600" }}>
							Fast<span style={{ color: "#63c29a" }}>Veri</span>
						</span>{" "}
						&mdash; już wkrótce narzędzie do weryfikacji kontrahenta z Polski w
						kilka sekund!
					</Typography>
					<Typography variant="body1">
						FastVeri to narzędzie, które po wpisaniu numeru NIP oraz dodaniu OCP
						umożliwi Państwu weryfikację kontrahenta jednocześnie w bazach KRS,
						CEIDG, KREPTD, VIES pod katem kluczowych dla bezpieczeństwa
						parametrów, a dla OCP pojawi się raport pod kątem kluczowych
						parametrów. Narzędzie będzie notyfikowało o parametrach wymagających
						szczególnej uwagi. Dodatkowo narzędzie dokona sprawdzenia, czy w
						adresie email piszącego widnieje literówka względem oficjalnej
						domeny kontrahenta oraz sprawdzi adres pod kątem wirtualnych biur,
						aktualności uprawnień czy polisy. Pełna lista możliwości jest
						większa, więcej szczegółów wkrótce. Nowe narzędzie umożliwi
						weryfikację wygodniej, dużo szybciej i podniesie bezpieczeństwo
						Twoich wyborów.
					</Typography>
				</Box>
			</Box>
		</>
	);
};

const ENContent = () => {
	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Typography variant="h4" align="center" color="error" gutterBottom>
					Important announcement.
				</Typography>
				<Typography variant="h6" sx={{ fontWeight: "600" }}>
					Dear All,
				</Typography>
				<Typography variant="body1">
					We would like to inform you that TIMOCOM has decided to end its
					cooperation with software providers that allow the simultaneous
					posting of loads to multiple freight exchanges. After two years of
					exemplary cooperation and the prior acceptance of our business model,
					this decision is incomprehensible to us. Therefore,{" "}
					<b>
						from April 1st, posting, deleting and refreshing loads to/from
						TIMOCOM will still be possible
					</b>{" "}
					in an automated way, as it is now, but only through our new app, which
					will be available for <b>download from March 27th</b>. A notification
					about this option will appear in the system.
				</Typography>
				<Typography variant="body1" sx={{ marginTop: "10px" }}>
					The new tool introduces a few changes:
				</Typography>
				<Box>
					<List dense={false} disablePadding={true}>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CloseIcon color="error" />
							</ListItemIcon>
							<ListItemText
								primary={`free vehicle offers from TIMOCOM will no longer be displayed`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CloseIcon color="error" />
							</ListItemIcon>
							<ListItemText
								primary={`editing the offer will no longer be possible on TIMOCOM (this can be replaced by the option "Post similar" with the desired change)`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText
								primary={`we have added the option to activate the blacklist function on TIMOCOM (exclusion list)`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText
								primary={`fast, manual refreshing of offers on TIMOCOM is available`}
							/>
						</ListItem>
						<ListItem disablePadding={true} disableGutters={true}>
							<ListItemIcon sx={{ minWidth: "30px" }}>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText
								primary={`carrier will be able to write to the published offers on TIMOCOM via the TIMOCOM messenger (currently only via e-mail)`}
							/>
						</ListItem>
					</List>
				</Box>
			</Box>
			<Box sx={{ marginTop: "20px" }}>
				<Typography variant="h6" sx={{ fontWeight: "600" }}>
					More new added values coming soon!
				</Typography>
				<Box sx={{ marginTop: "12px" }}>
					<Typography variant="body1">
						<span style={{ fontWeight: "600" }}>
							Transporeon and Comarr (CZ/SK)
						</span>{" "}
						&mdash; we have integrated two additional freight exchanges
					</Typography>
				</Box>
				<Box sx={{ marginTop: "12px" }}>
					<Typography variant="body1">
						<span style={{ fontWeight: "600" }}>
							Fast<span style={{ color: "#63c29a" }}>Veri</span>
						</span>{" "}
						&mdash; coming soon, a tool for verifying a Polish contractor in
						seconds!
					</Typography>
					<Typography variant="body1">
						FastVeri is a tool that, after entering the VAT no. and adding the
						insurance, will allow you to verify the contractor simultaneously
						across three government sources (CEIDG, KRS, KREPTD), as well as in
						the VIES databases for key security parameters. A report will also
						be generated for insurance purposes. The tool will notify you of
						parameters requiring special attention. Additionally, the tool will
						check the email address for typos against the contractor’s official
						domain, detect virtual office addresses, and verify the current
						status of licenses and insurance. The full list of features is even
						longer — more details will be shared soon. This new tool will enable
						faster, more convenient verification and significantly increase the
						security of your decisions.
					</Typography>
				</Box>
			</Box>
		</>
	);
};
